import script from "./MyBetsBetslips.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBetsBetslips.vue?vue&type=script&setup=true&lang=js"

import "./MyBetsBetslips.vue?vue&type=style&index=0&id=0c3903f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c3903f8"]])

export default __exports__